import { PatientDashboard as PatientDashboardComponent } from "components/features/patient";
import React from "react";

const PatientDashboard: React.FC = () => {
  return <PatientDashboardComponent />;
};

export default PatientDashboard;
